export default __webpack_public_path__ + "static/media/L_wdt_c_cap_2.5e32138f.mp3";